export class User {
    public static API_ENDPOINT = 'http://localhost/adsallweb/source/';
    //public static API_ENDPOINT = 'https://adsall.empyef.com/source/';
}
